export const SS_AUTH_TOKEN = "SS_AUTH_TOKEN";
export const SS_REFRESH_TOKEN = "SS_REFRESH_TOKEN";
export const SS_REF_HASH_ID = "SS_REF_HASH_ID";
export const SS_USER_HASH_ID = "SS_USER_HASH_ID";
export const SS_EMAIL = "SS_EMAIL";
export const SS_FIRST_NAME = "SS_FIRST_NAME";
export const SS_LAST_NAME = "SS_LAST_NAME";
export const SS_ROLE = "SS_ROLE";
export const SS_MOBILE_NUMBER = "SS_MOBILE_NUMBER";
export const SS_ACLS = "SS_ACLS";
export const SS_ACL_ARRAY = "SS_ACL_ARRAY";
export const SS_ADMIN_ID = "SS_ADMIN_ID";
export const SS_INDUSTRY_TYPE = "SS_INDUSTRY_TYPE";
export const SS_CLIENT_VERIFIED = "SS_CLIENT_VERIFIED";
export const SS_INTERNAL = "SS_INTERNAL";
export const SS_WHITELISTED_URL = "SS_WHITELISTED_URL";
export const SS_WHITELISTED_LOGO = "SS_WHITELISTED_LOGO";
export const SS_WHITELABELED = "SS_WHITELABELED";

export const SS_INTERVAL_ID = "SS_INTERVAL_ID";
export const SS_INTERVAL_TIME = "SS_INTERVAL_TIME";
